import Logo from "@/components/Logo";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-slate-300">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-4 max-w-sm text-sm text-slate-400 leading-relaxed">
            Transforme conhecimento em diversão. A plataforma brasileira para professores criarem
            quizzes interativos e jogos ao vivo.
          </p>
          <a
            href="mailto:educarte1000@gmail.com"
            className="mt-5 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors"
            data-testid="footer-contact-email"
          >
            <span className="w-8 h-8 rounded-full bg-brand-blue/20 flex items-center justify-center">
              <Mail className="w-4 h-4 text-brand-blue" />
            </span>
            educarte1000@gmail.com
          </a>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white mb-3 text-sm">Plataforma</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/planos" className="hover:text-white transition-colors">Planos</Link></li>
            <li><Link to="/atividades" className="hover:text-white transition-colors">Atividades por Turma</Link></li>
            <li><Link to="/cadastro" className="hover:text-white transition-colors">Criar conta</Link></li>
            <li><Link to="/jogar" className="hover:text-white transition-colors">Entrar em um jogo</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white mb-3 text-sm">Legal</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><span className="hover:text-white transition-colors cursor-pointer">Termos de uso</span></li>
            <li><span className="hover:text-white transition-colors cursor-pointer">Privacidade (LGPD)</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} EDUCARTE. Todos os direitos reservados.
      </div>
    </footer>
  );
}
